!(function (e, r) {
  "object" == typeof exports && "undefined" != typeof module
    ? (module.exports = r())
    : "function" == typeof define && define.amd
    ? define(r)
    : ((e =
        "undefined" != typeof globalThis ? globalThis : e || self).Pristine =
        r());
})(this, function () {
  "use strict";
  var e = {
    en: {
      required: "This field is required",
      email: "This field requires a valid e-mail address",
      number: "This field requires a number",
      integer: "This field requires an integer value",
      url: "This field requires a valid website URL",
      tel: "This field requires a valid telephone number",
      maxlength: "This fields length must be < ${1}",
      minlength: "This fields length must be > ${1}",
      min: "Minimum value for this field is ${1}",
      max: "Maximum value for this field is ${1}",
      pattern: "Please match the requested format",
      equals: "The two fields do not match"
    }
  };
  function r(e) {
    var r = arguments;
    return this.replace(/\${([^{}]*)}/g, function (e, t) {
      return r[t];
    });
  }
  function t(e) {
    return e.pristine.self.form.querySelectorAll(
      'input[name="' + e.getAttribute("name") + '"]:checked'
    ).length;
  }
  var n = {
      classTo: "form-group",
      errorClass: "has-danger",
      successClass: "has-success",
      errorTextParent: "form-group",
      errorTextTag: "div",
      errorTextClass: "text-help"
    },
    i = "pristine-error",
    s = "input:not([type^=hidden]):not([type^=submit]), select, textarea",
    a = ["required", "min", "max", "minlength", "maxlength", "pattern"],
    o =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    l = /-message(?:-([a-z]{2}(?:_[A-Z]{2})?))?/,
    u = "en",
    f = {},
    c = function (e, r) {
      (r.name = e), void 0 === r.priority && (r.priority = 1), (f[e] = r);
    };
  function p(t, o, c) {
    var p = this;
    function m(e, r, t, n) {
      var i = f[t];
      if (i && (e.push(i), n)) {
        var s = "pattern" === t ? [n] : n.split(",");
        s.unshift(null), (r[t] = s);
      }
    }
    function d(t) {
      for (var n = [], i = !0, s = 0; t.validators[s]; s++) {
        var a = t.validators[s],
          o = t.params[a.name] ? t.params[a.name] : [];
        if (
          ((o[0] = t.input.value),
          !a.fn.apply(t.input, o) &&
            ((i = !1),
            "function" == typeof a.msg
              ? n.push(a.msg(t.input.value, o))
              : "string" == typeof a.msg
              ? n.push(r.apply(a.msg, o))
              : a.msg === Object(a.msg) && a.msg[u]
              ? n.push(r.apply(a.msg[u], o))
              : t.messages[u] && t.messages[u][a.name]
              ? n.push(r.apply(t.messages[u][a.name], o))
              : e[u] && e[u][a.name] && n.push(r.apply(e[u][a.name], o)),
            !0 === a.halt))
        )
          break;
      }
      return (t.errors = n), i;
    }
    function h(e) {
      if (e.errorElements) return e.errorElements;
      var r = (function (e, r) {
          for (; (e = e.parentElement) && !e.classList.contains(r); );
          return e;
        })(e.input, p.config.classTo),
        t = null,
        n = null;
      return (
        (t =
          p.config.classTo === p.config.errorTextParent
            ? r
            : r.querySelector("." + p.config.errorTextParent)) &&
          ((n = t.querySelector("." + i)) ||
            (((n = document.createElement(p.config.errorTextTag)).className =
              i + " " + p.config.errorTextClass),
            t.appendChild(n),
            (n.pristineDisplay = n.style.display))),
        (e.errorElements = [r, n])
      );
    }
    function g(e) {
      var r = h(e),
        t = r[0],
        n = r[1];
      t &&
        (t.classList.remove(p.config.successClass),
        t.classList.add(p.config.errorClass)),
        n &&
          ((n.innerHTML = e.errors.join("<br/>")),
          (n.style.display = n.pristineDisplay || ""));
    }
    function v(e) {
      var r = (function (e) {
        var r = h(e),
          t = r[0],
          n = r[1];
        return (
          t &&
            (t.classList.remove(p.config.errorClass),
            t.classList.remove(p.config.successClass)),
          n && ((n.innerHTML = ""), (n.style.display = "none")),
          r
        );
      })(e)[0];
      r && r.classList.add(p.config.successClass);
    }
    return (
      (function (e, r, t) {
        e.setAttribute("novalidate", "true"),
          (p.form = e),
          (p.config = (function (e, r) {
            for (var t in r) t in e || (e[t] = r[t]);
            return e;
          })(r || {}, n)),
          (p.live = !(!1 === t)),
          (p.fields = Array.from(e.querySelectorAll(s)).map(
            function (e) {
              var r = [],
                t = {},
                n = {};
              return (
                [].forEach.call(e.attributes, function (e) {
                  if (/^data-pristine-/.test(e.name)) {
                    var i = e.name.substr(14),
                      s = i.match(l);
                    if (null !== s) {
                      var o = void 0 === s[1] ? "en" : s[1];
                      return (
                        n.hasOwnProperty(o) || (n[o] = {}),
                        void (n[o][i.slice(0, i.length - s[0].length)] =
                          e.value)
                      );
                    }
                    "type" === i && (i = e.value), m(r, t, i, e.value);
                  } else ~a.indexOf(e.name) ? m(r, t, e.name, e.value) : "type" === e.name && m(r, t, e.value);
                }),
                r.sort(function (e, r) {
                  return r.priority - e.priority;
                }),
                p.live &&
                  e.addEventListener(
                    ~["radio", "checkbox"].indexOf(e.getAttribute("type"))
                      ? "change"
                      : "input",
                    function (e) {
                      p.validate(e.target);
                    }.bind(p)
                  ),
                (e.pristine = {
                  input: e,
                  validators: r,
                  params: t,
                  messages: n,
                  self: p
                })
              );
            }.bind(p)
          ));
      })(t, o, c),
      (p.validate = function (e, r) {
        r = (e && !0 === r) || !0 === e;
        var t = p.fields;
        !0 !== e &&
          !1 !== e &&
          (e instanceof HTMLElement
            ? (t = [e.pristine])
            : (e instanceof NodeList ||
                e instanceof (window.$ || Array) ||
                e instanceof Array) &&
              (t = Array.from(e).map(function (e) {
                return e.pristine;
              })));
        for (var n = !0, i = 0; t[i]; i++) {
          var s = t[i];
          d(s) ? !r && v(s) : ((n = !1), !r && g(s));
        }
        return n;
      }),
      (p.getErrors = function (e) {
        if (!e) {
          for (var r = [], t = 0; t < p.fields.length; t++) {
            var n = p.fields[t];
            n.errors.length && r.push({ input: n.input, errors: n.errors });
          }
          return r;
        }
        return e.tagName && "select" === e.tagName.toLowerCase()
          ? e.pristine.errors
          : e.length
          ? e[0].pristine.errors
          : e.pristine.errors;
      }),
      (p.addValidator = function (e, r, t, n, i) {
        e instanceof HTMLElement
          ? (e.pristine.validators.push({
              fn: r,
              msg: t,
              priority: n,
              halt: i
            }),
            e.pristine.validators.sort(function (e, r) {
              return r.priority - e.priority;
            }))
          : console.warn("The parameter elem must be a dom element");
      }),
      (p.addError = function (e, r) {
        (e = e.length ? e[0] : e).pristine.errors.push(r), g(e.pristine);
      }),
      (p.reset = function () {
        for (var e = 0; p.fields[e]; e++) p.fields[e].errorElements = null;
        Array.from(p.form.querySelectorAll("." + i)).map(function (e) {
          e.parentNode.removeChild(e);
        }),
          Array.from(p.form.querySelectorAll("." + p.config.classTo)).map(
            function (e) {
              e.classList.remove(p.config.successClass),
                e.classList.remove(p.config.errorClass);
            }
          );
      }),
      (p.destroy = function () {
        p.reset(),
          p.fields.forEach(function (e) {
            delete e.input.pristine;
          }),
          (p.fields = []);
      }),
      (p.setGlobalConfig = function (e) {
        n = e;
      }),
      p
    );
  }
  return (
    c("text", {
      fn: function (e) {
        return !0;
      },
      priority: 0
    }),
    c("required", {
      fn: function (e) {
        return "radio" === this.type || "checkbox" === this.type
          ? t(this)
          : void 0 !== e && "" !== e;
      },
      priority: 99,
      halt: !0
    }),
    c("email", {
      fn: function (e) {
        return !e || o.test(e);
      }
    }),
    c("number", {
      fn: function (e) {
        return !e || !isNaN(parseFloat(e));
      },
      priority: 2
    }),
    c("integer", {
      fn: function (e) {
        return !e || /^\d+$/.test(e);
      }
    }),
    c("minlength", {
      fn: function (e, r) {
        return !e || e.length >= parseInt(r);
      }
    }),
    c("maxlength", {
      fn: function (e, r) {
        return !e || e.length <= parseInt(r);
      }
    }),
    c("min", {
      fn: function (e, r) {
        return (
          !e ||
          ("checkbox" === this.type
            ? t(this) >= parseInt(r)
            : parseFloat(e) >= parseFloat(r))
        );
      }
    }),
    c("max", {
      fn: function (e, r) {
        return (
          !e ||
          ("checkbox" === this.type
            ? t(this) <= parseInt(r)
            : parseFloat(e) <= parseFloat(r))
        );
      }
    }),
    c("pattern", {
      fn: function (e, r) {
        var t = r.match(new RegExp("^/(.*?)/([gimy]*)$"));
        return !e || new RegExp(t[1], t[2]).test(e);
      }
    }),
    c("equals", {
      fn: function (e, r) {
        var t = document.querySelector(r);
        return t && ((!e && !t.value) || t.value === e);
      }
    }),
    (p.addValidator = function (e, r, t, n, i) {
      c(e, { fn: r, msg: t, priority: n, halt: i });
    }),
    (p.addMessages = function (r, t) {
      var n = e.hasOwnProperty(r) ? e[r] : (e[r] = {});
      Object.keys(t).forEach(function (e, r) {
        n[e] = t[e];
      });
    }),
    (p.setLocale = function (e) {
      u = e;
    }),
    p
  );
});
